const ArrowLeftGifting = ({ ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.6095 7.05715C20.1302 7.57785 20.1302 8.42207 19.6095 8.94277L12.5523 16L19.6095 23.0572C20.1302 23.5779 20.1302 24.4221 19.6095 24.9428C19.0888 25.4635 18.2446 25.4635 17.7239 24.9428L9.72386 16.9428C9.20316 16.4221 9.20316 15.5779 9.72386 15.0572L17.7239 7.05715C18.2446 6.53645 19.0888 6.53645 19.6095 7.05715Z" />
    </svg>
  )
}

export default ArrowLeftGifting
